import { ReactNode } from "react";
import { Link } from "react-router";

import { IS_COPILOT } from "./constants";

type Props = {
  to: string;
  onClick: () => void;
  className: string;
  title?: string;
  preventNavigation?: boolean;
  disabled?: boolean;
  children: ReactNode;
};

function SiteNav({
  to,
  onClick,
  className,
  title,
  preventNavigation = false,
  disabled = false,
  children,
}: Props) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (preventNavigation || disabled) {
      event.preventDefault();
    }
    if (disabled) return;
    onClick();
  };

  // FIXME: change this to Link once copilot supports site switching without page reload
  return IS_COPILOT ? (
    <a
      href={`${to}`}
      onClick={handleClick}
      className={className}
      title={title}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
    >
      {children}
    </a>
  ) : (
    <Link
      to={to}
      onClick={handleClick}
      className={className}
      title={title}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
    >
      {children}
    </Link>
  );
}

export default SiteNav;
